// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("@rescript/std/lib/js/curry.js");
var Spice = require("@greenlabs/ppx-spice/src/rescript/Spice.bs.js");
var Js_exn = require("@rescript/std/lib/js/js_exn.js");
var Js_dict = require("@rescript/std/lib/js/js_dict.js");
var Js_json = require("@rescript/std/lib/js/js_json.js");
var $$Promise = require("../Promise.bs.js");
var Js_array = require("@rescript/std/lib/js/js_array.js");
var Nullable = require("../Nullable.bs.js");
var Belt_List = require("@rescript/std/lib/js/belt_List.js");
var Type_Club = require("../club/Type_Club.bs.js");
var Util_I18n = require("../util/Util_I18n.bs.js");
var Belt_Array = require("@rescript/std/lib/js/belt_Array.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Belt_Result = require("@rescript/std/lib/js/belt_Result.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Type_String = require("../type/Type_String.bs.js");
var Webapi__Fetch = require("rescript-webapi/src/Webapi/Webapi__Fetch.bs.js");
var Type_NextEpisode = require("../type/Type_NextEpisode.bs.js");

function envToString(env) {
  if (env === "preprod") {
    return "-preprod";
  } else {
    return "";
  }
}

var trailingSlashRegex = new RegExp("/$");

function createUrl(env, path) {
  return "https://api" + envToString(env) + ".arte.tv/api/sso/v3/" + path.replace(trailingSlashRegex, "");
}

function makeHeadersWithClient(headers) {
  return Belt_Array.concat([[
                "client",
                "web"
              ]], headers);
}

function makeFormBodyFromList(list) {
  return new URLSearchParams(Js_dict.fromList(list)).toString();
}

function error_t_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([[
                    "error",
                    true,
                    Spice.optionToJson(Spice.stringToJson, v.error)
                  ]]));
}

function error_t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var error = Spice.optionFromJson(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict._0, "error"), null));
  if (error.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              error: error._0
            }
          };
  }
  var e = error._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".error" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function reason_encode(v) {
  if (v) {
    return ["Other"];
  } else {
    return ["EmailNotVerified"];
  }
}

function reason_decode(v) {
  var json_arr = Js_json.classify(v);
  if (typeof json_arr === "number") {
    return Spice.error(undefined, "Not a variant", v);
  }
  if (json_arr.TAG !== /* JSONArray */3) {
    return Spice.error(undefined, "Not a variant", v);
  }
  var json_arr$1 = json_arr._0;
  if (json_arr$1.length === 0) {
    return Spice.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = Js_array.map(Js_json.classify, json_arr$1);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "EmailNotVerified" :
          if (tagged.length !== 1) {
            return Spice.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* EmailNotVerified */0
                  };
          }
      case "Other" :
          if (tagged.length !== 1) {
            return Spice.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Other */1
                  };
          }
      default:
        
    }
  }
  return Spice.error(undefined, "Invalid variant constructor", Belt_Array.getExn(json_arr$1, 0));
}

function exnToError(exn) {
  var tmp;
  if (exn.RE_EXN_ID === Js_exn.$$Error) {
    var name = exn._1.name;
    tmp = name === "AbortError" ? /* RequestAborted */6 : /* Unknow */4;
  } else {
    tmp = /* Unknow */4;
  }
  return Promise.resolve({
              TAG: /* Error */1,
              _0: tmp
            });
}

function parseJsonError(response) {
  return response.json().then(error_t_decode);
}

var $$Error = {
  error_t_encode: error_t_encode,
  error_t_decode: error_t_decode,
  reason_encode: reason_encode,
  reason_decode: reason_decode,
  exnToError: exnToError,
  parseJsonError: parseJsonError
};

async function parseResponse(decoder, response) {
  var status = response.status;
  if (status >= 200 && status < 300) {
    var value = await Curry._1(decoder, response);
    if (value.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: value._0
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: /* CantParseResponse */5
            };
    }
  }
  if (status >= 430) {
    if (status !== 500 && status !== 503) {
      return {
              TAG: /* Error */1,
              _0: {
                TAG: /* FailedWithStatus */1,
                _0: status
              }
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: /* ServerError */2
            };
    }
  }
  if (!(status === 401 || status === 400)) {
    if (status >= 429) {
      return {
              TAG: /* Error */1,
              _0: /* TooManyRequest */3
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: {
                TAG: /* FailedWithStatus */1,
                _0: status
              }
            };
    }
  }
  if (status >= 401) {
    return {
            TAG: /* Error */1,
            _0: /* InvalidAuthent */1
          };
  }
  var match = await response.json().then(error_t_decode);
  if (match.TAG !== /* Ok */0) {
    return {
            TAG: /* Error */1,
            _0: {
              TAG: /* BadRequest */0,
              _0: /* Other */1
            }
          };
  }
  var error = match._0.error;
  if (error === "email_not_verified") {
    return {
            TAG: /* Error */1,
            _0: {
              TAG: /* BadRequest */0,
              _0: /* EmailNotVerified */0
            }
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: {
              TAG: /* BadRequest */0,
              _0: /* Other */1
            }
          };
  }
}

function parseJsonResponse(decoder) {
  return function (param) {
    return parseResponse((function (response) {
                  return response.json().then(Curry.__1(decoder));
                }), param);
  };
}

function createConnectedBearerToken(token) {
  return "Bearer " + Curry._1(Type_String.User.Token.connectedToString, token);
}

function createBearerToken(token) {
  return Belt_Option.map(Curry._1(Type_String.User.Token.toString, token), (function (param) {
                return "Bearer ".concat(param);
              }));
}

function commonGetToString(commonGet) {
  switch (commonGet) {
    case /* Favorites */0 :
        return "favorites";
    case /* LastVieweds */1 :
        return "lastvieweds";
    case /* PersonalZone */2 :
        return "personalzone";
    case /* AcceptCom */3 :
        return "acceptcom";
    case /* TvCode */4 :
        return "code";
    
  }
}

function makeGet(signal, env, page, kind, token, language) {
  var bearerToken = createBearerToken(token);
  if (bearerToken === undefined) {
    return Promise.resolve({
                TAG: /* Error */1,
                _0: /* CantCreateBearerToken */0
              });
  }
  var headers = makeHeadersWithClient([[
          "Authorization",
          bearerToken
        ]]);
  var pageString = page !== undefined ? "?page=" + page.toString() + "" : "";
  var parseResponse = parseJsonResponse(Type_Club.teasersResponse_decode);
  var request = Webapi__Fetch.RequestInit.make(undefined, Caml_option.some(headers), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, signal)(undefined);
  return $$Promise.$$catch(fetch(createUrl(env, "" + commonGetToString(kind) + "/" + language + "" + pageString + ""), request).then(Curry.__1(parseResponse)).then(function (__x) {
                  return Belt_Result.map(__x, (function (response) {
                                return [
                                        Type_Club.$$Response.getData(response),
                                        Type_Club.$$Response.getNextPage(response)
                                      ];
                              }));
                }), exnToError);
}

function response_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([[
                    "msg",
                    false,
                    Nullable.t_encode(Spice.stringToJson, v.msg)
                  ]]));
}

function response_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var msg = Nullable.t_decode(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict._0, "msg"), null));
  if (msg.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              msg: msg._0
            }
          };
  }
  var e = msg._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".msg" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function t_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "token",
                    false,
                    Spice.optionToJson(Spice.stringToJson, v.token)
                  ],
                  [
                    "isauthenticated",
                    false,
                    Spice.boolToJson(v.isauthenticated)
                  ]
                ]));
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var token = Spice.optionFromJson(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "token"), null));
  if (token.TAG === /* Ok */0) {
    var isauthenticated = Spice.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "isauthenticated"), null));
    if (isauthenticated.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                token: token._0,
                isauthenticated: isauthenticated._0
              }
            };
    }
    var e = isauthenticated._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".isauthenticated" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = token._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".token" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function status_t_encode(v) {
  return Curry._1(Type_String.User.Token.t_encode, v);
}

function status_t_decode(v) {
  return Curry._1(Type_String.User.Token.t_decode, v);
}

function signin_t_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([[
                    "access_token",
                    false,
                    Nullable.t_encode(Spice.stringToJson, v.access_token)
                  ]]));
}

function signin_t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var access_token = Nullable.t_decode(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict._0, "access_token"), null));
  if (access_token.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              access_token: access_token._0
            }
          };
  }
  var e = access_token._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".access_token" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function createSsoLoginUrl(env, path) {
  return "https://auth" + envToString(env) + ".arte.tv/ssologin/" + path;
}

function logoutFirstCall(env, token) {
  if (typeof token === "number") {
    return Promise.resolve({
                TAG: /* Error */1,
                _0: /* CantCreateBearerToken */0
              });
  }
  if (token.TAG === /* Anonymous */0) {
    return Promise.resolve({
                TAG: /* Error */1,
                _0: /* CantCreateBearerToken */0
              });
  }
  var headers = makeHeadersWithClient([
        [
          "Authorization",
          createConnectedBearerToken(token._0)
        ],
        [
          "Content-Type",
          "application/json"
        ],
        [
          "accept",
          "application/json, text/plain, */*"
        ]
      ]);
  var request = Webapi__Fetch.RequestInit.make(/* Post */2, Caml_option.some(headers), "{\"shouldInvalidateToken\"=1}", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
  var parseResponse = parseJsonResponse(t_decode);
  return $$Promise.$$catch(fetch(createUrl(env, "logout"), request).then(Curry.__1(parseResponse)), exnToError);
}

function logoutSecondCall(env) {
  var headers = makeHeadersWithClient([[
          "Content-Type",
          "application/json"
        ]]);
  var request = Webapi__Fetch.RequestInit.make(/* Get */0, Caml_option.some(headers), undefined, undefined, undefined, undefined, /* Include */2, undefined, undefined, undefined, undefined, undefined)(undefined);
  var parseResponse = parseJsonResponse(t_decode);
  return $$Promise.$$catch(fetch(createSsoLoginUrl(env, "logout"), request).then(Curry.__1(parseResponse)), exnToError);
}

function login(envOpt, param) {
  var env = envOpt !== undefined ? envOpt : "prod";
  var request = Webapi__Fetch.RequestInit.make(undefined, Caml_option.some(makeHeadersWithClient([])), undefined, undefined, undefined, undefined, /* Include */2, undefined, undefined, undefined, undefined, undefined)(undefined);
  var parseResponse = parseJsonResponse(t_decode);
  return $$Promise.$$catch(fetch(createSsoLoginUrl(env, "login?shouldValidateAnonymous=true"), request).then(Curry.__1(parseResponse)).then(function (__x) {
                  return Belt_Result.map(__x, (function (param) {
                                var token = param.token;
                                if (token !== undefined && param.isauthenticated) {
                                  return Curry._1(Type_String.User.Token.make, token);
                                } else {
                                  return Type_String.User.Token.disconnected;
                                }
                              }));
                }), exnToError);
}

function signin(env, locale, email, password, token, ssoApiKey) {
  var headers = makeHeadersWithClient([
        [
          "Content-Type",
          "application/x-www-form-urlencoded"
        ],
        [
          "accept-language",
          Util_I18n.localeToString(locale)
        ],
        [
          "authorization",
          ssoApiKey
        ]
      ]);
  var requestData_0 = [
    "grant_type",
    "password"
  ];
  var requestData_1 = {
    hd: [
      "username",
      Curry._1(Type_String.User.Email.toString, email)
    ],
    tl: {
      hd: [
        "password",
        password
      ],
      tl: /* [] */0
    }
  };
  var requestData = {
    hd: requestData_0,
    tl: requestData_1
  };
  var requestData$1;
  requestData$1 = typeof token === "number" || token.TAG !== /* Anonymous */0 ? requestData : Belt_List.add(requestData, [
          "anonymous_token",
          Curry._1(Type_String.User.Token.anonymousToString, token._0)
        ]);
  var body = new URLSearchParams(Js_dict.fromList(requestData$1)).toString();
  var request = Webapi__Fetch.RequestInit.make(/* Post */2, Caml_option.some(headers), Caml_option.some(body), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
  var parseSigninResponse = parseJsonResponse(signin_t_decode);
  return $$Promise.$$catch(fetch(createUrl(env, "token"), request).then(Curry.__1(parseSigninResponse)), exnToError);
}

function registerPayload_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "email",
                    false,
                    Curry._1(Type_String.User.Email.t_encode, v.email)
                  ],
                  [
                    "password",
                    false,
                    Spice.stringToJson(v.password)
                  ],
                  [
                    "acceptTOS",
                    false,
                    Spice.boolToJson(v.acceptTOS)
                  ],
                  [
                    "nlarte",
                    false,
                    Spice.boolToJson(v.nlarte)
                  ],
                  [
                    "acceptCom",
                    false,
                    Spice.boolToJson(v.acceptCom)
                  ],
                  [
                    "language",
                    false,
                    Spice.stringToJson(v.language)
                  ]
                ]));
}

function registerPayload_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var email = Curry._1(Type_String.User.Email.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "email"), null));
  if (email.TAG === /* Ok */0) {
    var password = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "password"), null));
    if (password.TAG === /* Ok */0) {
      var acceptTOS = Spice.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "acceptTOS"), null));
      if (acceptTOS.TAG === /* Ok */0) {
        var nlarte = Spice.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "nlarte"), null));
        if (nlarte.TAG === /* Ok */0) {
          var acceptCom = Spice.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "acceptCom"), null));
          if (acceptCom.TAG === /* Ok */0) {
            var language = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "language"), null));
            if (language.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        email: email._0,
                        password: password._0,
                        acceptTOS: acceptTOS._0,
                        nlarte: nlarte._0,
                        acceptCom: acceptCom._0,
                        language: language._0
                      }
                    };
            }
            var e = language._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".language" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = acceptCom._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".acceptCom" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }
        var e$2 = nlarte._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".nlarte" + e$2.path,
                  message: e$2.message,
                  value: e$2.value
                }
              };
      }
      var e$3 = acceptTOS._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".acceptTOS" + e$3.path,
                message: e$3.message,
                value: e$3.value
              }
            };
    }
    var e$4 = password._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".password" + e$4.path,
              message: e$4.message,
              value: e$4.value
            }
          };
  }
  var e$5 = email._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".email" + e$5.path,
            message: e$5.message,
            value: e$5.value
          }
        };
}

var parseSetResponse = parseJsonResponse(function (param) {
      return {
              TAG: /* Ok */0,
              _0: undefined
            };
    });

function register(env, data, ssoApiKey, locale) {
  var headers = makeHeadersWithClient([
        [
          "Content-Type",
          "application/json"
        ],
        [
          "accept-language",
          Util_I18n.localeToString(locale)
        ],
        [
          "authorization",
          ssoApiKey
        ]
      ]);
  var body = JSON.stringify(registerPayload_encode(data));
  var request = Webapi__Fetch.RequestInit.make(/* Post */2, Caml_option.some(headers), Caml_option.some(body), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
  return $$Promise.$$catch(fetch(createUrl(env, "register"), request).then(Curry.__1(parseSetResponse)), exnToError);
}

function verifyPayload_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "isEmailUpdate",
                    false,
                    Spice.boolToJson(v.isEmailUpdate)
                  ],
                  [
                    "verificationToken",
                    false,
                    Spice.stringToJson(v.verificationToken)
                  ]
                ]));
}

function verifyPayload_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var isEmailUpdate = Spice.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "isEmailUpdate"), null));
  if (isEmailUpdate.TAG === /* Ok */0) {
    var verificationToken = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "verificationToken"), null));
    if (verificationToken.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                isEmailUpdate: isEmailUpdate._0,
                verificationToken: verificationToken._0
              }
            };
    }
    var e = verificationToken._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".verificationToken" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = isEmailUpdate._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".isEmailUpdate" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function verifyEmail(env, data, ssoApiKey, locale) {
  var headers = makeHeadersWithClient([
        [
          "Content-Type",
          "application/json"
        ],
        [
          "accept-language",
          Util_I18n.localeToString(locale)
        ],
        [
          "authorization",
          ssoApiKey
        ]
      ]);
  var body = JSON.stringify(verifyPayload_encode(data));
  var request = Webapi__Fetch.RequestInit.make(/* Post */2, Caml_option.some(headers), Caml_option.some(body), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
  var parseSigninResponse = parseJsonResponse(signin_t_decode);
  return $$Promise.$$catch(fetch(createUrl(env, "verify-email"), request).then(Curry.__1(parseSigninResponse)), exnToError);
}

function resetPasswordRequestPayload_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([[
                    "email",
                    false,
                    Curry._1(Type_String.User.Email.t_encode, v.email)
                  ]]));
}

function resetPasswordRequestPayload_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var email = Curry._1(Type_String.User.Email.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "email"), null));
  if (email.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              email: email._0
            }
          };
  }
  var e = email._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".email" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function resetPasswordRequest(env, data, ssoApiKey, locale) {
  var headers = makeHeadersWithClient([
        [
          "Content-Type",
          "application/json"
        ],
        [
          "accept-language",
          Util_I18n.localeToString(locale)
        ],
        [
          "authorization",
          ssoApiKey
        ]
      ]);
  var body = JSON.stringify(resetPasswordRequestPayload_encode(data));
  var request = Webapi__Fetch.RequestInit.make(/* Post */2, Caml_option.some(headers), Caml_option.some(body), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
  var parseSigninResponse = parseJsonResponse(signin_t_decode);
  return $$Promise.$$catch(fetch(createUrl(env, "password/forgot"), request).then(Curry.__1(parseSigninResponse)), exnToError);
}

function resetPasswordQueryPayload_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "password",
                    false,
                    Spice.stringToJson(v.password)
                  ],
                  [
                    "resettoken",
                    false,
                    Spice.stringToJson(v.resetToken)
                  ]
                ]));
}

function resetPasswordQueryPayload_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var password = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "password"), null));
  if (password.TAG === /* Ok */0) {
    var resetToken = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "resettoken"), null));
    if (resetToken.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                password: password._0,
                resetToken: resetToken._0
              }
            };
    }
    var e = resetToken._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "." + ("resettoken" + e.path),
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = password._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".password" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function resetPasswordQuery(env, data, ssoApiKey, locale) {
  var headers = makeHeadersWithClient([
        [
          "Content-Type",
          "application/json"
        ],
        [
          "accept-language",
          Util_I18n.localeToString(locale)
        ],
        [
          "authorization",
          ssoApiKey
        ]
      ]);
  var body = JSON.stringify(resetPasswordQueryPayload_encode(data));
  var request = Webapi__Fetch.RequestInit.make(/* Put */3, Caml_option.some(headers), Caml_option.some(body), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
  var parseSigninResponse = parseJsonResponse(signin_t_decode);
  return $$Promise.$$catch(fetch(createUrl(env, "password/reset"), request).then(Curry.__1(parseSigninResponse)), exnToError);
}

function setToken(env, token, ssoTokenApiKey) {
  if (typeof token === "number") {
    return Promise.resolve({
                TAG: /* Error */1,
                _0: /* CantCreateBearerToken */0
              });
  }
  if (token.TAG === /* Anonymous */0) {
    return Promise.resolve({
                TAG: /* Error */1,
                _0: /* CantCreateBearerToken */0
              });
  }
  var headers = makeHeadersWithClient([[
          "Content-Type",
          "application/json"
        ]]);
  var url = "setCustomToken?token=" + Curry._1(Type_String.User.Token.connectedToString, token._0) + "&apikey=" + ssoTokenApiKey;
  var request = Webapi__Fetch.RequestInit.make(/* Get */0, Caml_option.some(headers), undefined, undefined, undefined, undefined, /* Include */2, undefined, undefined, undefined, undefined, undefined)(undefined);
  var parseSigninResponse = parseJsonResponse(signin_t_decode);
  return $$Promise.$$catch(fetch(createSsoLoginUrl(env, url), request).then(Curry.__1(parseSigninResponse)), exnToError);
}

function logout(env, token) {
  return Promise.all([
              logoutFirstCall(env, token),
              logoutSecondCall(env)
            ]);
}

var Auth = {
  response_encode: response_encode,
  response_decode: response_decode,
  t_encode: t_encode,
  t_decode: t_decode,
  status_t_encode: status_t_encode,
  status_t_decode: status_t_decode,
  signin_t_encode: signin_t_encode,
  signin_t_decode: signin_t_decode,
  createSsoLoginUrl: createSsoLoginUrl,
  logoutFirstCall: logoutFirstCall,
  logoutSecondCall: logoutSecondCall,
  login: login,
  signin: signin,
  registerPayload_encode: registerPayload_encode,
  registerPayload_decode: registerPayload_decode,
  parseSetResponse: parseSetResponse,
  register: register,
  verifyPayload_encode: verifyPayload_encode,
  verifyPayload_decode: verifyPayload_decode,
  verifyEmail: verifyEmail,
  resetPasswordRequestPayload_encode: resetPasswordRequestPayload_encode,
  resetPasswordRequestPayload_decode: resetPasswordRequestPayload_decode,
  resetPasswordRequest: resetPasswordRequest,
  resetPasswordQueryPayload_encode: resetPasswordQueryPayload_encode,
  resetPasswordQueryPayload_decode: resetPasswordQueryPayload_decode,
  resetPasswordQuery: resetPasswordQuery,
  setToken: setToken,
  logout: logout
};

function lastViewed_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "programId",
                    false,
                    Spice.stringToJson(v.programId)
                  ],
                  [
                    "timecode",
                    false,
                    Spice.intToJson(v.timecode)
                  ],
                  [
                    "progress",
                    false,
                    Spice.floatToJson(v.progress)
                  ]
                ]));
}

function lastViewed_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var programId = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "programId"), null));
  if (programId.TAG === /* Ok */0) {
    var timecode = Spice.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timecode"), null));
    if (timecode.TAG === /* Ok */0) {
      var progress = Spice.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "progress"), null));
      if (progress.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  programId: programId._0,
                  timecode: timecode._0,
                  progress: progress._0
                }
              };
      }
      var e = progress._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".progress" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = timecode._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".timecode" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = programId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".programId" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function nextEpisode_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "seriesId",
                    true,
                    Spice.optionToJson(Spice.stringToJson, v.seriesId)
                  ],
                  [
                    "seasonId",
                    true,
                    Spice.optionToJson(Spice.stringToJson, v.seasonId)
                  ],
                  [
                    "nextEpisodeId",
                    true,
                    Spice.optionToJson(Spice.stringToJson, v.nextEpisodeId)
                  ],
                  [
                    "season",
                    true,
                    Spice.optionToJson(Spice.intToJson, v.season)
                  ],
                  [
                    "episode",
                    true,
                    Spice.optionToJson(Spice.intToJson, v.episode)
                  ],
                  [
                    "totalEpisodes",
                    true,
                    Spice.optionToJson(Spice.intToJson, v.totalEpisodes)
                  ],
                  [
                    "seasonProgress",
                    true,
                    Spice.optionToJson(Spice.floatToJson, v.seasonProgress)
                  ]
                ]));
}

function nextEpisode_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var seriesId = Spice.optionFromJson(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "seriesId"), null));
  if (seriesId.TAG === /* Ok */0) {
    var seasonId = Spice.optionFromJson(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "seasonId"), null));
    if (seasonId.TAG === /* Ok */0) {
      var nextEpisodeId = Spice.optionFromJson(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "nextEpisodeId"), null));
      if (nextEpisodeId.TAG === /* Ok */0) {
        var season = Spice.optionFromJson(Spice.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "season"), null));
        if (season.TAG === /* Ok */0) {
          var episode = Spice.optionFromJson(Spice.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "episode"), null));
          if (episode.TAG === /* Ok */0) {
            var totalEpisodes = Spice.optionFromJson(Spice.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "totalEpisodes"), null));
            if (totalEpisodes.TAG === /* Ok */0) {
              var seasonProgress = Spice.optionFromJson(Spice.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "seasonProgress"), null));
              if (seasonProgress.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          seriesId: seriesId._0,
                          seasonId: seasonId._0,
                          nextEpisodeId: nextEpisodeId._0,
                          season: season._0,
                          episode: episode._0,
                          totalEpisodes: totalEpisodes._0,
                          seasonProgress: seasonProgress._0
                        }
                      };
              }
              var e = seasonProgress._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".seasonProgress" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = totalEpisodes._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".totalEpisodes" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = episode._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".episode" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
        }
        var e$3 = season._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".season" + e$3.path,
                  message: e$3.message,
                  value: e$3.value
                }
              };
      }
      var e$4 = nextEpisodeId._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".nextEpisodeId" + e$4.path,
                message: e$4.message,
                value: e$4.value
              }
            };
    }
    var e$5 = seasonId._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".seasonId" + e$5.path,
              message: e$5.message,
              value: e$5.value
            }
          };
  }
  var e$6 = seriesId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".seriesId" + e$6.path,
            message: e$6.message,
            value: e$6.value
          }
        };
}

function t_encode$1(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "favorites",
                    true,
                    Spice.optionToJson((function (param) {
                            return Spice.arrayToJson(Spice.stringToJson, param);
                          }), v.favorites)
                  ],
                  [
                    "subscriptions",
                    true,
                    Spice.optionToJson((function (param) {
                            return Spice.arrayToJson(Spice.stringToJson, param);
                          }), v.subscriptions)
                  ],
                  [
                    "lastvieweds",
                    true,
                    Spice.optionToJson((function (param) {
                            return Spice.arrayToJson(lastViewed_encode, param);
                          }), v.lastvieweds)
                  ],
                  [
                    "nextEpisodes",
                    true,
                    Spice.optionToJson((function (param) {
                            return Spice.arrayToJson(nextEpisode_encode, param);
                          }), v.nextEpisodes)
                  ]
                ]));
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var favorites = Spice.optionFromJson((function (param) {
          return Spice.arrayFromJson(Spice.stringFromJson, param);
        }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "favorites"), null));
  if (favorites.TAG === /* Ok */0) {
    var subscriptions = Spice.optionFromJson((function (param) {
            return Spice.arrayFromJson(Spice.stringFromJson, param);
          }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "subscriptions"), null));
    if (subscriptions.TAG === /* Ok */0) {
      var lastvieweds = Spice.optionFromJson((function (param) {
              return Spice.arrayFromJson(lastViewed_decode, param);
            }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "lastvieweds"), null));
      if (lastvieweds.TAG === /* Ok */0) {
        var nextEpisodes = Spice.optionFromJson((function (param) {
                return Spice.arrayFromJson(nextEpisode_decode, param);
              }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "nextEpisodes"), null));
        if (nextEpisodes.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    favorites: favorites._0,
                    subscriptions: subscriptions._0,
                    lastvieweds: lastvieweds._0,
                    nextEpisodes: nextEpisodes._0
                  }
                };
        }
        var e = nextEpisodes._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".nextEpisodes" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = lastvieweds._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".lastvieweds" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = subscriptions._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".subscriptions" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = favorites._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".favorites" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

async function get(env, signal, token) {
  var bearerToken = createBearerToken(token);
  if (bearerToken === undefined) {
    return {
            TAG: /* Error */1,
            _0: /* CantCreateBearerToken */0
          };
  }
  var parseResponse = parseJsonResponse(t_decode$1);
  var headers = makeHeadersWithClient([[
          "Authorization",
          bearerToken
        ]]);
  var request = Webapi__Fetch.RequestInit.make(undefined, Caml_option.some(headers), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, Caml_option.some(signal))(undefined);
  var url = createUrl(env, "me/data");
  try {
    var response = await fetch(url, request);
    return await Curry._1(parseResponse, response);
  }
  catch (exn){
    return {
            TAG: /* Error */1,
            _0: /* Unknow */4
          };
  }
}

var Data = {
  lastViewed_encode: lastViewed_encode,
  lastViewed_decode: lastViewed_decode,
  nextEpisode_encode: nextEpisode_encode,
  nextEpisode_decode: nextEpisode_decode,
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  get: get
};

function toTypeClubUser(result) {
  return Belt_Result.mapWithDefault(result, Type_Club.User.defaultValue, (function (response) {
                return Belt_Option.getWithDefault(Belt_Array.get(Type_Club.$$Response.getData(response), 0), Type_Club.User.defaultValue);
              }));
}

function get$1(env, signal, token) {
  if (typeof token === "number") {
    return Promise.resolve({
                TAG: /* Error */1,
                _0: /* CantCreateBearerToken */0
              });
  }
  if (token.TAG === /* Anonymous */0) {
    return Promise.resolve({
                TAG: /* Error */1,
                _0: /* CantCreateBearerToken */0
              });
  }
  var parseResponse = parseJsonResponse(Type_Club.User.t_decode);
  var headers = makeHeadersWithClient([[
          "Authorization",
          createConnectedBearerToken(token._0)
        ]]);
  var request = Webapi__Fetch.RequestInit.make(undefined, Caml_option.some(headers), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, Caml_option.some(signal))(undefined);
  return $$Promise.$$catch(fetch(createUrl(env, "me"), request).then(Curry.__1(parseResponse)), exnToError);
}

function put(env, data, token) {
  if (typeof token === "number") {
    return Promise.resolve({
                TAG: /* Error */1,
                _0: /* CantCreateBearerToken */0
              });
  }
  if (token.TAG === /* Anonymous */0) {
    return Promise.resolve({
                TAG: /* Error */1,
                _0: /* CantCreateBearerToken */0
              });
  }
  var parseResponse = parseJsonResponse(Type_Club.User.t_decode);
  var headers = makeHeadersWithClient([
        [
          "Authorization",
          createConnectedBearerToken(token._0)
        ],
        [
          "Content-Type",
          "application/x-www-form-urlencoded"
        ]
      ]);
  var makeRequestData = function (user) {
    return {
            hd: [
              "gender",
              user.gender
            ],
            tl: {
              hd: [
                "email",
                Curry._1(Type_String.User.Email.toString, user.email)
              ],
              tl: {
                hd: [
                  "lastName",
                  user.lastName
                ],
                tl: {
                  hd: [
                    "firstName",
                    user.firstName
                  ],
                  tl: {
                    hd: [
                      "birthdate",
                      user.birthday
                    ],
                    tl: {
                      hd: [
                        "street",
                        user.street
                      ],
                      tl: {
                        hd: [
                          "zipCode",
                          user.postCode
                        ],
                        tl: {
                          hd: [
                            "city",
                            user.city
                          ],
                          tl: {
                            hd: [
                              "country",
                              user.country
                            ],
                            tl: /* [] */0
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          };
  };
  var list = makeRequestData(data);
  var body = new URLSearchParams(Js_dict.fromList(list)).toString();
  var request = Webapi__Fetch.RequestInit.make(/* Put */3, Caml_option.some(headers), Caml_option.some(body), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
  return $$Promise.$$catch(fetch(createUrl(env, "me"), request).then(Curry.__1(parseResponse)), exnToError);
}

function response_encode$1(v) {
  return Js_dict.fromArray(Spice.filterOptional([[
                    "msg",
                    false,
                    Nullable.t_encode(Spice.stringToJson, v.msg)
                  ]]));
}

function response_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var msg = Nullable.t_decode(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict._0, "msg"), null));
  if (msg.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              msg: msg._0
            }
          };
  }
  var e = msg._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".msg" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function parseResponse$1(response) {
  return parseJsonResponse(response_decode$1)(response).then(function (response) {
              return Belt_Result.map(response, (function (param) {
                            return /* EmailSent */0;
                          }));
            });
}

function call(env, locale, email, token) {
  if (typeof token === "number") {
    return Promise.resolve({
                TAG: /* Error */1,
                _0: /* CantCreateBearerToken */0
              });
  }
  if (token.TAG === /* Anonymous */0) {
    return Promise.resolve({
                TAG: /* Error */1,
                _0: /* CantCreateBearerToken */0
              });
  }
  var headers = makeHeadersWithClient([
        [
          "Authorization",
          createConnectedBearerToken(token._0)
        ],
        [
          "Content-Type",
          "application/x-www-form-urlencoded"
        ],
        [
          "accept-language",
          Util_I18n.localeToString(locale)
        ]
      ]);
  var requestData_0 = [
    "email",
    Curry._1(Type_String.User.Email.toString, email)
  ];
  var requestData = {
    hd: requestData_0,
    tl: /* [] */0
  };
  var body = new URLSearchParams(Js_dict.fromList(requestData)).toString();
  var request = Webapi__Fetch.RequestInit.make(/* Post */2, Caml_option.some(headers), Caml_option.some(body), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
  return $$Promise.$$catch(fetch(createUrl(env, "me/new-email"), request).then(parseResponse$1), exnToError);
}

var NewEmail = {
  response_encode: response_encode$1,
  response_decode: response_decode$1,
  parseResponse: parseResponse$1,
  call: call
};

function response_encode$2(v) {
  return Js_dict.fromArray(Spice.filterOptional([[
                    "msg",
                    false,
                    Nullable.t_encode(Spice.stringToJson, v.msg)
                  ]]));
}

function response_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var msg = Nullable.t_decode(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict._0, "msg"), null));
  if (msg.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              msg: msg._0
            }
          };
  }
  var e = msg._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".msg" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function parseResponse$2(response) {
  return parseJsonResponse(response_decode$2)(response).then(function (response) {
              return Belt_Result.map(response, (function (param) {
                            return /* EmailSent */0;
                          }));
            });
}

function call$1(env, locale, oldpassword, newpassword, token) {
  if (typeof token === "number") {
    return Promise.resolve({
                TAG: /* Error */1,
                _0: /* CantCreateBearerToken */0
              });
  }
  if (token.TAG === /* Anonymous */0) {
    return Promise.resolve({
                TAG: /* Error */1,
                _0: /* CantCreateBearerToken */0
              });
  }
  var headers = makeHeadersWithClient([
        [
          "Authorization",
          createConnectedBearerToken(token._0)
        ],
        [
          "Content-Type",
          "application/x-www-form-urlencoded"
        ],
        [
          "accept-language",
          Util_I18n.localeToString(locale)
        ]
      ]);
  var requestData_0 = [
    "oldpassword",
    oldpassword
  ];
  var requestData_1 = {
    hd: [
      "newpassword",
      newpassword
    ],
    tl: /* [] */0
  };
  var requestData = {
    hd: requestData_0,
    tl: requestData_1
  };
  var body = new URLSearchParams(Js_dict.fromList(requestData)).toString();
  var request = Webapi__Fetch.RequestInit.make(/* Put */3, Caml_option.some(headers), Caml_option.some(body), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
  return $$Promise.$$catch(fetch(createUrl(env, "me/password"), request).then(parseResponse$2), exnToError);
}

var NewPassword = {
  response_encode: response_encode$2,
  response_decode: response_decode$2,
  parseResponse: parseResponse$2,
  call: call$1
};

function call$2(env, locale, token) {
  if (typeof token === "number") {
    return Promise.resolve({
                TAG: /* Error */1,
                _0: /* CantCreateBearerToken */0
              });
  }
  if (token.TAG === /* Anonymous */0) {
    return Promise.resolve({
                TAG: /* Error */1,
                _0: /* CantCreateBearerToken */0
              });
  }
  var decoder = function (param) {
    return Promise.resolve({
                TAG: /* Ok */0,
                _0: /* AccountDeleted */0
              });
  };
  var parseResponse$3 = function (param) {
    return parseResponse(decoder, param);
  };
  var headers = makeHeadersWithClient([
        [
          "Authorization",
          createConnectedBearerToken(token._0)
        ],
        [
          "accept-language",
          Util_I18n.localeToString(locale)
        ]
      ]);
  var request = Webapi__Fetch.RequestInit.make(/* Delete */4, Caml_option.some(headers), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
  return $$Promise.$$catch(fetch(createUrl(env, "me"), request).then(parseResponse$3), exnToError);
}

var Delete = {
  call: call$2
};

var Me = {
  Data: Data,
  toTypeClubUser: toTypeClubUser,
  get: get$1,
  put: put,
  NewEmail: NewEmail,
  NewPassword: NewPassword,
  Delete: Delete
};

function decodeResponse(param) {
  return {
          TAG: /* Ok */0,
          _0: ""
        };
}

var parseResponse$3 = parseJsonResponse(decodeResponse);

function unSubscribe(env, token, magazineId) {
  var headers = makeHeadersWithClient([
        [
          "Authorization",
          createConnectedBearerToken(token)
        ],
        [
          "Content-Type",
          "application/x-www-form-urlencoded"
        ]
      ]);
  var request = Webapi__Fetch.RequestInit.make(/* Delete */4, Caml_option.some(headers), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
  return $$Promise.$$catch(fetch(createUrl(env, "magazines/subscriptions/" + magazineId + ""), request).then(Curry.__1(parseResponse$3)), exnToError);
}

function subscribe(env, token, magazineId) {
  var headers = makeHeadersWithClient([
        [
          "Authorization",
          createConnectedBearerToken(token)
        ],
        [
          "Content-Type",
          "application/x-www-form-urlencoded"
        ]
      ]);
  var requestData_0 = [
    "programId",
    magazineId
  ];
  var requestData = {
    hd: requestData_0,
    tl: /* [] */0
  };
  var body = new URLSearchParams(Js_dict.fromList(requestData)).toString();
  var request = Webapi__Fetch.RequestInit.make(/* Put */3, Caml_option.some(headers), Caml_option.some(body), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
  return $$Promise.$$catch(fetch(createUrl(env, "magazines/subscriptions"), request).then(Curry.__1(parseResponse$3)), exnToError);
}

var Magazines = {
  decodeResponse: decodeResponse,
  parseResponse: parseResponse$3,
  unSubscribe: unSubscribe,
  subscribe: subscribe
};

function setCustomToken_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "ok",
                    false,
                    Spice.boolToJson(v.ok)
                  ],
                  [
                    "access_token",
                    false,
                    Spice.stringToJson(v.access_token)
                  ]
                ]));
}

function setCustomToken_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var ok = Spice.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "ok"), null));
  if (ok.TAG === /* Ok */0) {
    var access_token = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "access_token"), null));
    if (access_token.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                ok: ok._0,
                access_token: access_token._0
              }
            };
    }
    var e = access_token._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".access_token" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = ok._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".ok" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function url(env, token) {
  return "https://auth" + envToString(env) + ".arte.tv/ssologin/setCustomToken?shouldValidateAnonymous=true&token=" + token;
}

function decodeSetCustomToken(setCustomToken) {
  var err = setCustomToken_decode(setCustomToken);
  if (err.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: Curry._1(Type_String.User.Token.make, err._0.access_token)
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: err._0
          };
  }
}

function setCustomToken(env, token) {
  var parseResponse = parseJsonResponse(decodeSetCustomToken);
  var request = Webapi__Fetch.RequestInit.make(undefined, Caml_option.some(makeHeadersWithClient([])), undefined, undefined, undefined, undefined, /* Include */2, undefined, undefined, undefined, undefined, undefined)(undefined);
  return $$Promise.$$catch(fetch(url(env, token), request).then(Curry.__1(parseResponse)), exnToError);
}

function t_encode$2(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "token_type",
                    false,
                    Spice.stringToJson(v.token_type)
                  ],
                  [
                    "access_token",
                    false,
                    Spice.stringToJson(v.access_token)
                  ],
                  [
                    "expires_in",
                    false,
                    Spice.optionToJson(Spice.stringToJson, v.expires_in)
                  ]
                ]));
}

function t_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var token_type = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "token_type"), null));
  if (token_type.TAG === /* Ok */0) {
    var access_token = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "access_token"), null));
    if (access_token.TAG === /* Ok */0) {
      var expires_in = Spice.optionFromJson(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "expires_in"), null));
      if (expires_in.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  token_type: token_type._0,
                  access_token: access_token._0,
                  expires_in: expires_in._0
                }
              };
      }
      var e = expires_in._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".expires_in" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = access_token._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".access_token" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = token_type._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".token_type" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function decode(t) {
  var err = t_decode$2(t);
  if (err.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: err._0.access_token
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: err._0
          };
  }
}

var parseResponse$4 = parseJsonResponse(decode);

function get$2(envOpt, param) {
  var env = envOpt !== undefined ? envOpt : "prod";
  var headers = makeHeadersWithClient([
        [
          "Authorization",
          "I6k2z58YGO08P1X0E8A7VBOjDxr8Lecg"
        ],
        [
          "Content-Type",
          "application/x-www-form-urlencoded"
        ]
      ]);
  var request = Webapi__Fetch.RequestInit.make(/* Post */2, Caml_option.some(headers), "grant_type=anonymous&username=&password=&assertion=", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
  return $$Promise.$$catch(fetch(createUrl(env, "token"), request).then(Curry.__1(parseResponse$4)).then(function (response) {
                  if (response.TAG === /* Ok */0) {
                    return setCustomToken(env, response._0);
                  } else {
                    return Promise.resolve({
                                TAG: /* Error */1,
                                _0: response._0
                              });
                  }
                }), exnToError);
}

var Token = {
  setCustomToken_encode: setCustomToken_encode,
  setCustomToken_decode: setCustomToken_decode,
  url: url,
  decodeSetCustomToken: decodeSetCustomToken,
  setCustomToken: setCustomToken,
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  decode: decode,
  parseResponse: parseResponse$4,
  get: get$2
};

var parseGetResponse = parseJsonResponse(Type_Club.VideoInProgress.videosInProgress_decode);

function get$3(signal, env, token, language) {
  return makeGet(Caml_option.some(signal), env, undefined, /* LastVieweds */1, token, language);
}

function getById(env, token, language, programId) {
  var bearerToken = createBearerToken(token);
  if (bearerToken === undefined) {
    return Promise.resolve({
                TAG: /* Error */1,
                _0: /* CantCreateBearerToken */0
              });
  }
  var headers = makeHeadersWithClient([[
          "Authorization",
          bearerToken
        ]]);
  var programId$1 = Curry._1(Type_String.Program.Id.toString, programId);
  var request = Webapi__Fetch.RequestInit.make(undefined, Caml_option.some(headers), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
  return $$Promise.$$catch(fetch(createUrl(env, "lastvieweds/" + language + "/" + programId$1 + ""), request).then(Curry.__1(parseGetResponse)).then(function (__x) {
                  return Belt_Result.map(__x, Type_Club.VideoInProgress.getFirstTeaser);
                }), exnToError);
}

function requestBody_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "programId",
                    false,
                    Curry._1(Type_String.Teaser.DsId.t_encode, v.programId)
                  ],
                  [
                    "timecode",
                    false,
                    Spice.intToJson(v.timecode)
                  ]
                ]));
}

function requestBody_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var programId = Curry._1(Type_String.Teaser.DsId.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "programId"), null));
  if (programId.TAG === /* Ok */0) {
    var timecode = Spice.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timecode"), null));
    if (timecode.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                programId: programId._0,
                timecode: timecode._0
              }
            };
    }
    var e = timecode._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".timecode" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = programId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".programId" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

var parseSetResponse$1 = parseJsonResponse(function (param) {
      return {
              TAG: /* Ok */0,
              _0: undefined
            };
    });

function set(env, token, programId, timecode) {
  var bearerToken = createBearerToken(token);
  if (bearerToken === undefined) {
    return Promise.resolve({
                TAG: /* Error */1,
                _0: /* CantCreateBearerToken */0
              });
  }
  var headers = makeHeadersWithClient([
        [
          "Authorization",
          bearerToken
        ],
        [
          "Content-Type",
          "application/json"
        ]
      ]);
  var body = JSON.stringify(requestBody_encode({
            programId: programId,
            timecode: timecode
          }));
  var request = Webapi__Fetch.RequestInit.make(/* Put */3, Caml_option.some(headers), Caml_option.some(body), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
  return $$Promise.$$catch(fetch(createUrl(env, "lastvieweds"), request).then(Curry.__1(parseSetResponse$1)), exnToError);
}

var LastVieweds = {
  parseGetResponse: parseGetResponse,
  get: get$3,
  getById: getById,
  requestBody_encode: requestBody_encode,
  requestBody_decode: requestBody_decode,
  parseSetResponse: parseSetResponse$1,
  set: set
};

function get$4(signal, env, token, language) {
  return makeGet(Caml_option.some(signal), env, undefined, /* Favorites */0, token, language);
}

function add(env, token, language, programId) {
  if (token === undefined) {
    return Promise.resolve({
                TAG: /* Error */1,
                _0: /* CantCreateBearerToken */0
              });
  }
  var bearerToken = createBearerToken(token);
  if (bearerToken === undefined) {
    return Promise.resolve({
                TAG: /* Error */1,
                _0: /* CantCreateBearerToken */0
              });
  }
  var headers = makeHeadersWithClient([
        [
          "Authorization",
          bearerToken
        ],
        [
          "Content-Type",
          "application/x-www-form-urlencoded"
        ],
        [
          "accept-language",
          language
        ]
      ]);
  var requestData_0 = [
    "programId",
    programId
  ];
  var requestData = {
    hd: requestData_0,
    tl: /* [] */0
  };
  var body = new URLSearchParams(Js_dict.fromList(requestData)).toString();
  var parseResponse = parseJsonResponse(Type_Club.Favorite.favorites_decode);
  var request = Webapi__Fetch.RequestInit.make(/* Put */3, Caml_option.some(headers), Caml_option.some(body), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
  return $$Promise.$$catch(fetch(createUrl(env, "favorites"), request).then(Curry.__1(parseResponse)).then(function (__x) {
                  return Belt_Result.map(__x, Type_Club.Favorite.getFirstTeaser);
                }), exnToError);
}

function $$delete(env, token, programId) {
  if (token === undefined) {
    return Promise.resolve({
                TAG: /* Error */1,
                _0: /* CantCreateBearerToken */0
              });
  }
  var bearerToken = createBearerToken(token);
  if (bearerToken === undefined) {
    return Promise.resolve({
                TAG: /* Error */1,
                _0: /* CantCreateBearerToken */0
              });
  }
  var headers = makeHeadersWithClient([
        [
          "Authorization",
          bearerToken
        ],
        [
          "Content-Type",
          "application/x-www-form-urlencoded"
        ]
      ]);
  var decode = function (param) {
    return {
            TAG: /* Ok */0,
            _0: ""
          };
  };
  var parseResponse = parseJsonResponse(decode);
  var request = Webapi__Fetch.RequestInit.make(/* Delete */4, Caml_option.some(headers), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
  return $$Promise.$$catch(fetch(createUrl(env, "favorites/" + programId + ""), request).then(Curry.__1(parseResponse)), exnToError);
}

var Favorites = {
  get: get$4,
  add: add,
  $$delete: $$delete
};

function get$5(signal, env, token, language) {
  return makeGet(Caml_option.some(signal), env, undefined, /* PersonalZone */2, token, language);
}

var PersonalZone = {
  get: get$5
};

function get$6(env, token, language, id) {
  var bearerToken = createBearerToken(token);
  if (bearerToken === undefined) {
    return Promise.resolve({
                TAG: /* Error */1,
                _0: /* CantCreateBearerToken */0
              });
  }
  var headers = makeHeadersWithClient([[
          "Authorization",
          bearerToken
        ]]);
  var parseResponse = parseJsonResponse(Type_NextEpisode.ApiResponse.response_decode);
  var request = Webapi__Fetch.RequestInit.make(undefined, Caml_option.some(headers), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
  return $$Promise.$$catch(fetch(createUrl(env, "nextEpisode/" + Util_I18n.localeToString(language) + "/" + id + ""), request).then(Curry.__1(parseResponse)).then(function (__x) {
                    return Belt_Result.map(__x, Type_NextEpisode.ApiResponse.get);
                  }).then(function (__x) {
                  return Belt_Result.map(__x, (function (__x) {
                                return Belt_Option.map(__x, Type_NextEpisode.make);
                              }));
                }), exnToError);
}

var ContinueWatching = {
  get: get$6
};

function get$7(token, language, t, page) {
  var arg = page;
  return function (param) {
    return makeGet(undefined, param, arg, t, token, language);
  };
}

var NextPage = {
  get: get$7
};

function response_encode$3(v) {
  return Js_dict.fromArray(Spice.filterOptional([[
                    "msg",
                    false,
                    Spice.stringToJson(v.msg)
                  ]]));
}

function response_decode$3(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var msg = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict._0, "msg"), null));
  if (msg.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              msg: msg._0
            }
          };
  }
  var e = msg._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".msg" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function put$1(env, token, language, enabled) {
  if (token === undefined) {
    return Promise.resolve({
                TAG: /* Error */1,
                _0: /* CantCreateBearerToken */0
              });
  }
  var bearerToken = createBearerToken(token);
  if (bearerToken === undefined) {
    return Promise.resolve({
                TAG: /* Error */1,
                _0: /* CantCreateBearerToken */0
              });
  }
  var headers = makeHeadersWithClient([
        [
          "Authorization",
          bearerToken
        ],
        [
          "Content-Type",
          "application/x-www-form-urlencoded"
        ],
        [
          "accept-language",
          language
        ]
      ]);
  var requestData_0 = [
    "acceptCom",
    enabled ? "true" : "false"
  ];
  var requestData = {
    hd: requestData_0,
    tl: /* [] */0
  };
  var body = new URLSearchParams(Js_dict.fromList(requestData)).toString();
  var parseResponse = parseJsonResponse(response_decode$3);
  var request = Webapi__Fetch.RequestInit.make(/* Put */3, Caml_option.some(headers), Caml_option.some(body), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
  return $$Promise.$$catch(fetch(createUrl(env, "acceptCom"), request).then(Curry.__1(parseResponse)), exnToError);
}

var AcceptCom = {
  response_encode: response_encode$3,
  response_decode: response_decode$3,
  put: put$1
};

function response_encode$4(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "code",
                    false,
                    Spice.stringToJson(v.code)
                  ],
                  [
                    "expires_in",
                    false,
                    Spice.stringToJson(v.expires_in)
                  ]
                ]));
}

function response_decode$4(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var code = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "code"), null));
  if (code.TAG === /* Ok */0) {
    var expires_in = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "expires_in"), null));
    if (expires_in.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                code: code._0,
                expires_in: expires_in._0
              }
            };
    }
    var e = expires_in._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".expires_in" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = code._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".code" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function get$8(env, token, language) {
  if (token === undefined) {
    return Promise.resolve({
                TAG: /* Error */1,
                _0: /* CantCreateBearerToken */0
              });
  }
  var bearerToken = createBearerToken(token);
  if (bearerToken === undefined) {
    return Promise.resolve({
                TAG: /* Error */1,
                _0: /* CantCreateBearerToken */0
              });
  }
  var headers = makeHeadersWithClient([
        [
          "Authorization",
          bearerToken
        ],
        [
          "accept-language",
          language
        ]
      ]);
  var parseResponse = parseJsonResponse(response_decode$4);
  var request = Webapi__Fetch.RequestInit.make(/* Get */0, Caml_option.some(headers), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
  return $$Promise.$$catch(fetch(createUrl(env, "code"), request).then(Curry.__1(parseResponse)), exnToError);
}

var TvCode = {
  response_encode: response_encode$4,
  response_decode: response_decode$4,
  get: get$8
};

exports.envToString = envToString;
exports.trailingSlashRegex = trailingSlashRegex;
exports.createUrl = createUrl;
exports.makeHeadersWithClient = makeHeadersWithClient;
exports.makeFormBodyFromList = makeFormBodyFromList;
exports.$$Error = $$Error;
exports.parseResponse = parseResponse;
exports.parseJsonResponse = parseJsonResponse;
exports.createConnectedBearerToken = createConnectedBearerToken;
exports.createBearerToken = createBearerToken;
exports.commonGetToString = commonGetToString;
exports.makeGet = makeGet;
exports.Auth = Auth;
exports.Me = Me;
exports.Magazines = Magazines;
exports.Token = Token;
exports.LastVieweds = LastVieweds;
exports.Favorites = Favorites;
exports.PersonalZone = PersonalZone;
exports.ContinueWatching = ContinueWatching;
exports.NextPage = NextPage;
exports.AcceptCom = AcceptCom;
exports.TvCode = TvCode;
/* trailingSlashRegex Not a pure module */
